var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sky-textarea"},[_c('el-input',_vm._b({directives:[{name:"focus",rawName:"v-focus",value:(_vm.focus),expression:"focus"}],ref:"input",attrs:{"type":"textarea","value":_vm.value},on:{"input":_vm.handleChange}},'el-input',_vm.$attrs,false)),(_vm.tips)?_c('div',{staticClass:"tip"},[_vm._v(_vm._s(_vm.tips))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }